import { SOUND_DETAILS_LOADING, SOUND_DETAILS_SUCCESS, SOUND_DETAILS_FAILED, SOUND_DETAILS_RESET, SOUND_DETAILS_FILTER, SOUND_PAGINATE_SUCCESS, SOUND_PAGINATE_LOADING,SOUND_DETAILS_FILTER_FALSE} from '../actions/soundManager.action';
import { SoundManagerReducer } from '../models/soundManager.interface';


const initialState: SoundManagerReducer = {
    filteredData:{},
    soundsData: {
        data: [],
        tags: {},
        total: 0,
    },
    soundsLoading: true,
    soundsError: false,
    soundsErrorMsg: '',
    soundSuccess: false,
    soundFilter: false,
    total: 0,
    totalSounds: -1,
    paginationLoading: false,

}

const soundManagerReducer = (state: SoundManagerReducer = initialState, action: any): SoundManagerReducer => {

    switch (action.type) {
        case SOUND_DETAILS_LOADING:
            return {
                ...state,
                soundsLoading: true,
                soundsError: false,
                // paginationLoading: true,
            }
        case SOUND_DETAILS_SUCCESS:
            return {
                ...state,
                soundsLoading: false,
                soundsError: false,
                soundsData: action.payload.res,
                soundSuccess: true,
                total: action.payload.res.total,
                totalSounds: action.payload.res.total,

            }
        case SOUND_DETAILS_FAILED:
            return {
                ...state,
                soundsLoading: false,
                soundsError: true,
                soundsErrorMsg: action.payload.error
            }
        case SOUND_DETAILS_FILTER:
            return {
                ...state,
                soundFilter: true,
                filteredData:action.payload
            }
        case SOUND_DETAILS_FILTER_FALSE:
            return {
                    ...state,
                    filteredData:{},
                    soundsData: {
                        ...state.soundsData,
                        data: [...[]],
                        tags: {...{}},
                        total: 0,
                    },
                    soundFilter: false
            }
        case SOUND_PAGINATE_SUCCESS:
            return {
                ...state,
                soundsData: {
                    ...state.soundsData,
                    data: [...state.soundsData.data, ...action.payload.res.data],
                    tags: action.payload.res.tags,
                    total: action.payload.res.total
                },
                soundsError: false,
                paginationLoading: false
            }
        case SOUND_PAGINATE_LOADING:
            return {
                ...state,
                paginationLoading: true,
            }
        case SOUND_DETAILS_RESET:
            return initialState
        default:
            return state;
    }
}

export default soundManagerReducer;